import graphql from "../../graphql";

export default {
  namespaced: true,
  actions: {
    fetchCurrentUser: context => {
      graphql
        .query({ query: currentUserQuery })
        .then(response => {
          context.commit("setCurrentUser", response.data.currentUser);
        })
        .catch(() => {});
    },
    checkAbility: ({ commit }, data) => {
      graphql
        .query({ query: abilityQuery(), variables: data })
        .then(response =>
          commit("setAbilityForEntity", { data, can: response.data.currentUser.able })
        )
        .catch(() => {});
    },
    fetchAdultContentCookie: ({ commit }) => {
      const adultContentAllowed = document.cookie.includes("adult_content=true");
      commit("setAdultContentAllowed", adultContentAllowed);
      commit("setShowAdultContentWarning", !adultContentAllowed);
    },
  },
  getters: {
    currentUser: state => state,
    isAdmin: state => state.roles.includes("admin"),
    isShopManager: state => state.roles.includes("shop_manager"),
    isCityManager: state => state.roles.includes("city_manager"),
    isPersisted: state => state.roles.includes("persisted"),
    isAnonymous: state => state.roles.includes("anonymous"),
    adultContentAllowed: state => state.adultContentAllowed,
    showAdultContentWarning: state => state.showAdultContentWarning,
    can: state => (action, identifier) => {
      if (state.abilities[identifier]) {
        return state.abilities[identifier][action];
      }
      return false;
    },
  },
  mutations: {
    setAbilityForEntity: (state, { data, can }) => {
      state.abilities = {
        ...state.abilities,
        ...(data.subject
          ? {
              [data.subject]: {
                ...state.abilities[data.globalHashid],
                [data.action]: can,
              },
            }
          : {}),
        ...(data.globalHashid
          ? {
              [data.globalHashid]: {
                ...state.abilities[data.globalHashid],
                [data.action]: can,
              },
            }
          : {}),
      };
    },
    setCurrentUser: (state, { email, roles }) => {
      state.email = email;
      state.roles = roles;
    },
    setAdultContentAllowed: (state, bool) => (state.adultContentAllowed = bool),
    setShowAdultContentWarning: (state, bool) => (state.showAdultContentWarning = bool),
  },
  state: {
    abilities: {},
    email: "",
    roles: [],
    adultContentAllowed: false,
    showAdultContentWarning: false,
  },
};

const currentUserQuery = `
  query {
    currentUser {
      email
      roles
    }
  }
`;

const abilityQuery = () => `
  query Ability($action: AbilityActionEnum!, $globalHashid: ID, $subject: String){
    currentUser {
      able(action: $action, id: $globalHashid, subject: $subject)
    }
  }
`;
